import '../styles.css';
import { fetchVideoMetadata } from './services/youtube.service';
import { generateTitleVariations } from './services/claude.service';
import { showLoading, hideLoading, showError, hideError, createMetadataHTML, createTitleVariationsHTML, } from './utils/dom';
function extractVideoId(url) {
    const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
        /youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
        /youtube\.com\/v\/([a-zA-Z0-9_-]{11})/,
    ];
    for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match && match[1]) {
            return match[1];
        }
    }
    return null;
}
function createVideoEmbed(videoId) {
    return `
    <iframe
      width="100%"
      height="450"
      src="https://www.youtube.com/embed/${videoId}"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  `;
}
async function loadVideo() {
    const input = document.getElementById('videoInput');
    const videoContainer = document.getElementById('videoContainer');
    const metadataContainer = document.getElementById('metadataContainer');
    const variationsContainer = document.getElementById('variationsContainer');
    if (!input || !videoContainer || !metadataContainer || !variationsContainer) {
        return;
    }
    const url = input.value.trim();
    if (!url) {
        showError('Please enter a YouTube URL', () => {
            hideError();
            input.value = '';
        });
        return;
    }
    const videoId = extractVideoId(url);
    if (!videoId) {
        showError('Invalid YouTube URL. Please enter a valid YouTube video link.', () => {
            hideError();
            videoContainer.innerHTML = '';
            metadataContainer.innerHTML = '';
            variationsContainer.innerHTML = '';
            input.value = '';
            input.focus();
        });
        return;
    }
    hideError();
    videoContainer.innerHTML = '';
    metadataContainer.innerHTML = '';
    variationsContainer.innerHTML = '';
    try {
        videoContainer.innerHTML = createVideoEmbed(videoId);
        showLoading('metadataContainer', 'Loading video information...');
        const metadata = await fetchVideoMetadata(videoId);
        hideLoading('metadataContainer');
        metadataContainer.innerHTML = createMetadataHTML(metadata);
        showLoading('variationsContainer', 'Generating creative title variations...');
        const variations = await generateTitleVariations(metadata.title);
        hideLoading('variationsContainer');
        variationsContainer.innerHTML = createTitleVariationsHTML(variations);
    }
    catch (error) {
        hideLoading('metadataContainer');
        hideLoading('variationsContainer');
        const errorMessage = error instanceof Error ? `Error: ${error.message}` : 'An unexpected error occurred. Please try again.';
        showError(errorMessage, () => {
            hideError();
            videoContainer.innerHTML = '';
            metadataContainer.innerHTML = '';
            variationsContainer.innerHTML = '';
            input.value = '';
            input.focus();
        });
    }
}
function init() {
    const loadButton = document.getElementById('loadButton');
    const input = document.getElementById('videoInput');
    if (loadButton) {
        loadButton.addEventListener('click', loadVideo);
    }
    if (input) {
        input.addEventListener('keypress', (event) => {
            if (event.key === 'Enter') {
                loadVideo();
            }
        });
    }
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
}
else {
    init();
}
